var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container has-background-primary" }, [
    _c("div", { staticClass: "modal-header has-text-yell" }, [
      _c("b", [
        _vm._v(
          _vm._s(_vm.wordVariant ? "Protected Word" : "Trademark Protected")
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showSuccess,
            expression: "!showSuccess"
          }
        ],
        staticClass: "modal-body"
      },
      [
        _c("div", [
          _c("b", [
            _vm._v(
              "The word or phrase you entered is available but protected" +
                _vm._s(_vm.wordVariant ? "" : " by trademarks") +
                ".  " +
                _vm._s(
                  _vm.wordVariant
                    ? "If you would like to purchase this slink"
                    : "If you are the trademark owner and would like to claim this slink"
                ) +
                ", please contact "
            ),
            _vm._m(0),
            _vm._v(".")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "has-text-centered" }, [
          _c(
            "div",
            {
              staticClass: "has-text-centered is-size-3 top25 has-text-warning"
            },
            [_c("b", [_vm._v(_vm._s(_vm.slink))])]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top25" }, [
          _vm._v(
            "\n                 If you already obtained a claim validation code from us, please enter it here to claim your slink:"
          ),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "has-text-centered" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.code,
                  expression: "code"
                }
              ],
              staticClass:
                "input is-warning whiteInput top5 bottom5 has-text-dark",
              attrs: { type: "text", placeholder: "enter code" },
              domProps: { value: _vm.code },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.code = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.invalid,
                    expression: "invalid"
                  }
                ],
                staticClass: "is-size-6",
                staticStyle: { color: "red" }
              },
              [_vm._v("Invalid Code!")]
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-warning is-small top20",
                attrs: { id: "sendButt" },
                on: { click: _vm.sendCode }
              },
              [_c("b", [_vm._v("SUBMIT CODE")])]
            ),
            _vm._v("  \n                     "),
            _c(
              "button",
              {
                staticClass: "button top20 is-small",
                on: { click: _vm.cancel }
              },
              [_vm._v("CANCEL")]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSuccess,
            expression: "showSuccess"
          }
        ],
        staticClass: "has-text-centered"
      },
      [
        _c("div", { staticClass: "is-size-4 top60" }, [
          _vm._v("Congratulations!")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top20" }, [
          _vm._v("The slink, "),
          _c("b", [_vm._v('"' + _vm._s(_vm.slink) + '"')]),
          _vm._v(
            " has been added to your shopping cart. You may add more items to your shopping cart or proceed to checkout."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "has-text-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-warning top20",
              on: { click: _vm.cancel }
            },
            [_vm._v("DONE")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { color: "white" },
        attrs: { href: "mailto:legal@slink.com" }
      },
      [_c("b", [_vm._v("legal@slink.com")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55240cc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55240cc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalClaims.vue
// module id = null
// module chunks = 